<template>
  <div class="newsItem">
    <PcSolveShow class="PC"/>
    <MdSolveShow class="MD"/>
  </div>
</template>

<script>
// 移动端
import MdSolveShow from './MdSolveShow.vue'
// pc端
import PcSolveShow from './PcSolveShow.vue'
export default {
  name: 'newsMain',
  components: {
    PcSolveShow,
    MdSolveShow
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .newsItem{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .newsItem{
    .MD{
      display: none;
    }
  }
}
</style>
